import { useEffect } from "react";
import { useAppSelector } from "../../redux-store/CustomReduxHooks";
import {
  E_ChannelOptions,
  T_GTMBaseEvents,
} from "../../globalTypes/GlobalTypes";
import { isEmpty } from "lodash";
import useDeviceDetection from "../../hooks/useDeviceDetection";
import { DEVICE_TYPE } from "../../utils/constants";

export class GTM_CLS_COMMON {
  static eventObj: T_GTMBaseEvents = {
    Client_ID: "",
    journey_id: "",
    previous_screen_name: "",
    User_ID: "",
    user_status: "",
    golden_id: "",
    guest_id: "",
    distinct_id: "",
    clevertap_id: "",
    appsflyer_id: "",
    platform: "",
  };
  static setBaseData(updatedEventObj: T_GTMBaseEvents) {
    this.eventObj = { ...updatedEventObj };
  }
}

const useGtmBaseLogic = () => {
  const deviceType = useDeviceDetection();
  const csAppSlice = useAppSelector((state) => state.CsAppSlice);
  const loginSlice = useAppSelector((state) => state.LoginSlice);
  const userDetails = useAppSelector((state) => state.CsAppSlice.userDetails);
  const isUserActive = useAppSelector(
    (state) => state.GeneralAppElementsSlice.isConsentReceived,
  );

  useEffect(() => {
    const isSuperApp = csAppSlice.channel === E_ChannelOptions.SUPER_APP;
    const isMobileApp = !isEmpty(csAppSlice.NativeDeviceInfo?.deviceName);
    const clientID = csAppSlice.csUserId || userDetails?.CS_USER_ID || "";
    const isMobile = deviceType === DEVICE_TYPE.MOBILE;
    const traceId = csAppSlice?.csUserId || "";
    const ciiNumber =
      userDetails?.customerAndLobDetails?.find(
        (f) => f.PRIMARY_SECONDARY_USER === "primary",
      )?.CII || "";
    const cleverTapId = window.clevertap?.getCleverTapID
      ? window.clevertap.getCleverTapID()
      : "";
    const onboardingChannelId =
      csAppSlice.channel === E_ChannelOptions.SUPER_APP
        ? "ABCD"
        : csAppSlice.channel === E_ChannelOptions.CSAPP
          ? "ABCS"
          : csAppSlice.channel;

    GTM_CLS_COMMON.setBaseData({
      Client_ID: isMobile ? clientID : "",
      previous_screen_name: "",
      journey_id: onboardingChannelId,
      User_ID: loginSlice.isUserLoggedIn ? clientID : "",
      user_status: isUserActive ? "registered" : "not_registered",
      golden_id: ciiNumber,
      guest_id: "NA",
      distinct_id: traceId,
      clevertap_id: cleverTapId || "NA",
      appsflyer_id: "NA",
      platform: isSuperApp
        ? "abcd_app"
        : isMobileApp
          ? "abc_app"
          : "abc_website",
    });
  }, [
    csAppSlice?.channel,
    csAppSlice?.csUserId,
    deviceType,
    isUserActive,
    userDetails?.CS_USER_ID,
    userDetails?.customerAndLobDetails,
  ]);
};

export default useGtmBaseLogic;
